import { ActionType, getType, StateType } from 'typesafe-actions'
import { IAnswer } from 'types/IAnswer'
import * as actions from './actions'

export type QuestionActions = ActionType<typeof actions>

const answersReducer = (
  state: (IAnswer | undefined)[] = [],
  action: QuestionActions
) => {
  if (action.type === getType(actions.updateAnswer)) {
    const newState = [...state]
    newState[action.payload.questionIndex] = {
      answer: action.payload.answer,
      axis: action.payload.axis
    }
    return newState
  }
  return state
}

export { answersReducer }
export type QuestionsState = StateType<typeof answersReducer>
